module.exports = __webpack_public_path__ + "img/rep-tara.24e4ad9b.png";